import { render, staticRenderFns } from "./InfoRequest.vue?vue&type=template&id=ac8946a8"
import script from "./InfoRequest.vue?vue&type=script&lang=js"
export * from "./InfoRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports